import * as firebase from 'firebase/app'
import 'firebase/auth'
import Vue from 'vue'
import VueRouter from 'vue-router'
const Index = () => import(/* webpackChunkName: "Index" */ '../components/Index.vue')
const Main = () => import(/* webpackChunkName: "Main" */ '../components/Main.vue')
const Uninstall = () => import(/* webpackChunkName: "Uninstall" */ '../components/Uninstall.vue')
const Library = () => import(/* webpackChunkName: "Uninstall" */ '../components/Library.vue')
const Share = () => import(/* webpackChunkName: "Uninstall" */ '../components/Share/Share.vue')
Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'index',
  component: Index
},
{
  path: '/app',
  name: 'main',
  component: Main,
  meta: {
    requiresAuth: true
  }
},
{
  path: '/uninstall',
  name: 'uninstall',
  component: Uninstall,
  meta: {
    requiresAuth: 'neutral'
  }
},
{
  path: '/library',
  name: 'library',
  component: Library,
  meta: {
    requiresAuth: 'neutral'
  }
},
{
  path: '/share/:deckId/:cardId',
  name: 'share',
  component: Share,
  meta: {
    requiresAuth: 'neutral'
  }
}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  let currentUser = firebase.auth().currentUser
  const requiresAuth = to.meta.requiresAuth || false

  if (requiresAuth === 'neutral') {
    next()
  } else if (requiresAuth && !currentUser) {
    next({
      name: 'index'
    })
  } else if (!requiresAuth && currentUser) {
    next({
      name: 'main'
    })
  } else next()
})
export default router
